import { Box, Card, Container, Stack } from "@mui/material"
import { Suspense, useContext } from "react"
import { Outlet } from "react-router"

import OriginalsLogo from "@sap/assets/logo/Originals"
import SatellietLogo from "@sap/assets/logo/Satelliet"
import SatellietIcon from "@sap/assets/logo/SatellietIcon"
import LoadingScreen from "@sap/components/loading-screen"

import { DomainContext } from "@/routes/providers/originals"

import { StyledRoot } from "./styles"

export default function LoginLayout() {
  const { isOriginals } = useContext(DomainContext)
  return (
    <StyledRoot
      sx={{
        backgroundImage: isOriginals
          ? "url(/assets/images/originals_login_background.jpg)"
          : "url(/assets/images/loginbackground.jpg)",
      }}
    >
      <Box
        component="header"
        sx={{
          position: "fixed",
          left: 0,
          top: 0,
          right: 0,
          zIndex: 9999,
        }}
      >
        <Container>
          <Stack
            direction="row"
            sx={{
              alignItems: "center",
              height: 64,
            }}
          >
            <SatellietIcon width={36} height={36} />
          </Stack>
        </Container>
      </Box>
      <Container component="main">
        <Stack
          sx={{
            py: 12,
            m: "auto",
            maxWidth: 450,
            minHeight: "100vh",
            justifyContent: "center",
          }}
        >
          <Card sx={{ p: 5 }}>
            <Stack
              spacing={2}
              sx={{
                alignItems: "stretch",
                mb: 2,
              }}
            >
              <Stack
                direction="row"
                sx={{
                  justifyContent: "center",
                }}
              >
                {isOriginals ? <OriginalsLogo width={300} /> : <SatellietLogo width={300} />}
              </Stack>
              <Suspense fallback={<LoadingScreen isDashboard />}>
                <Outlet />
              </Suspense>
            </Stack>
          </Card>
        </Stack>
      </Container>
    </StyledRoot>
  )
}
